import { render } from "./index.vue?vue&type=template&id=49c505e6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=49c505e6&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__